import { Theme, Tab as MuiTab, styled } from '@mui/material';

interface StyledTabProps {
    value: string | number;
    label: any;
}

const StyledTab = styled(MuiTab)(({ theme }) => ({
    color: '#3b454d', // Color not available in theme
    background: 'transparent',
    fontSize: '1.3rem',
    maxWidth: '20rem',
    minWidth: 'fit-content !important',
    borderBottom: 'solid 0.1rem #ebebed',
    marginBottom: '-0.1rem',
    padding: '0 1rem',
    borderTopLeftRadius: '0.4rem',
    borderTopRightRadius: '0.4rem',
    transition: 'all 0.5s ease-out',
    minHeight: '4rem',
    height: '4rem',
    '&:focus': {
        opacity: 1,
    },
    '& p': {
        fontSize: '1.3rem',
        wordBreak: 'break-word',
        wordWrap: 'break-word',
        overflow: 'auto',
        textAlign: 'left',
        textTransform: 'none !important',
    },
    '& .tab-count': {
        fontWeight: 'normal',
        fontSize: '1.3rem',
        marginLeft: '0.8rem',
    },
    '&.Mui-selected': {
        border: 'solid 0.1rem #ebebed',
        borderBottom: 'solid 0.1rem transparent',
        background: '#fff',
        boxShadow: '0 0 1.6rem 0 rgba(0,0,0,0.11)',
        '& p': {
            color: theme.palette.common.black,
            fontWeight: 'bolder',
        },
    },
}));

export const Tab = (props: StyledTabProps) => (
    <StyledTab disableRipple {...props} />
);